/* script */



















































































































































import { DisplayMode, displayReferenceObjects } from './display_mode';
import { tl } from '../languages';

const __vue_script__ = {
	data() {return {
		axes: [0, 1, 2],
		reference_model: 'player',
		pose_angle: 0,
		slot: new DisplaySlot(''),
		allow_mirroring: Settings.get('allow_display_slot_mirror'),
		animate_preview: DisplayMode.animate_preview
	}},
	watch: {
		pose_angle(value) {
			if (!displayReferenceObjects.active) return;
			displayReferenceObjects.active.pose_angles[DisplayMode.display_slot] = value;
			if (displayReferenceObjects.active.updateBasePosition) displayReferenceObjects.active.updateBasePosition();
		},
		animate_preview(value) {
			DisplayMode.animate_preview = value;
		}
	},
	methods: {
		tl,
		allowMirroring() {
			return this.allow_mirroring && !this.isBedrockStyle();
		},
		allowEnablingMirroring() {
			return Format.id != 'bedrock_block';
		},
		isBedrockStyle() {
			return Format.id == 'bedrock_block';
		},
		isMirrored: (axis) => {
			if (Project.display_settings[DisplayMode.display_slot]) {
				return Project.display_settings[DisplayMode.display_slot].scale[axis] < 0;
			}
		},
		change: (axis, channel) => {
			if (channel === 'scale') {
				if (Pressing.shift || Pressing.overrides.shift) {
					var val = limitNumber(parseFloat(DisplayMode.slot.scale[axis]), 0, 4)
					DisplayMode.slot.scale[0] = val;
					DisplayMode.slot.scale[1] = val;
					DisplayMode.slot.scale[2] = val;
				}
			}
			DisplayMode.updateDisplayBase()
		},
		focusout: (axis, channel) => {
			if (channel === 'scale') {
				var val = limitNumber(DisplayMode.slot.scale[axis], 0, 4)
				DisplayMode.slot.scale[axis] = val;
				if (Pressing.shift || Pressing.overrides.shift) {
					DisplayMode.slot.scale[0] = val;
					DisplayMode.slot.scale[1] = val;
					DisplayMode.slot.scale[2] = val;
				}
			} else if (channel === 'translation') {
				DisplayMode.slot.translation[axis] = limitNumber(DisplayMode.slot.translation[axis], -80, 80)||0;
			} else if (channel == 'rotation') {
				DisplayMode.slot.rotation[axis] = Math.trimDeg(DisplayMode.slot.rotation[axis])||0;
			} else {
				DisplayMode.slot[channel][axis] = DisplayMode.slot[channel][axis] ?? 0;
			}
			DisplayMode.updateDisplayBase()
		},
		resetChannel: (channel) => {
			var v = channel === 'scale' ? 1 : 0;
			Undo.initEdit({display_slots: [DisplayMode.display_slot]})
			DisplayMode.slot.extend({[channel]: [v, v, v]})
			if (channel === 'scale') {
			DisplayMode.slot.extend({mirror: [false, false, false]})
			}
			Undo.finishEdit('Reset display channel')
		},
		invert: (axis) => {
			Undo.initEdit({display_slots: [DisplayMode.display_slot]})
			DisplayMode.slot.mirror[axis] = !DisplayMode.slot.mirror[axis];
			DisplayMode.slot.update()
			Undo.finishEdit('Mirror display setting')
		},
		start: () => {
			Undo.initEdit({display_slots: [DisplayMode.display_slot]});
			Interface.addSuggestedModifierKey('shift', 'modifier_actions.uniform_scaling');
		},
		save: () => {
			Undo.finishEdit('Change display setting');
			Interface.removeSuggestedModifierKey('shift', 'modifier_actions.uniform_scaling');
		},
		toggleFitToFrame() {
			Undo.initEdit({display_slots: [DisplayMode.display_slot]});
			this.slot.fit_to_frame = !this.slot.fit_to_frame;
			Undo.finishEdit('Change display setting fit-to-frame property');
			Interface.removeSuggestedModifierKey('shift', 'modifier_actions.uniform_scaling');
		},
		showMirroringSetting() {
			Settings.openDialog({search_term: tl('settings.allow_display_slot_mirror')});
		},
		getAxisLetter
	},
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "toolbar_wrapper display" }),
    _vm._v(" "),
    _c("p", { staticClass: "panel_toolbar_label" }, [
      _vm._v(_vm._s(_vm.tl("display.slot"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bar tabs_small icon_bar", attrs: { id: "display_bar" } },
      [
        _c("input", {
          staticClass: "hidden",
          attrs: {
            type: "radio",
            name: "display",
            id: "thirdperson_righthand",
            checked: "",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "tool",
            attrs: {
              for: "thirdperson_righthand",
              onclick: "DisplayMode.loadThirdRight()",
            },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _vm._v(_vm._s(_vm.tl("display.slot.third_right"))),
            ]),
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("accessibility"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "hidden",
          attrs: { type: "radio", name: "display", id: "thirdperson_lefthand" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "tool",
            attrs: {
              for: "thirdperson_lefthand",
              onclick: "DisplayMode.loadThirdLeft()",
            },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _vm._v(_vm._s(_vm.tl("display.slot.third_left"))),
            ]),
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("accessibility"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "hidden",
          attrs: {
            type: "radio",
            name: "display",
            id: "firstperson_righthand",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "tool",
            attrs: {
              for: "firstperson_righthand",
              onclick: "DisplayMode.loadFirstRight()",
            },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _vm._v(_vm._s(_vm.tl("display.slot.first_right"))),
            ]),
            _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "hidden",
          attrs: { type: "radio", name: "display", id: "firstperson_lefthand" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "tool",
            attrs: {
              for: "firstperson_lefthand",
              onclick: "DisplayMode.loadFirstLeft()",
            },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _vm._v(_vm._s(_vm.tl("display.slot.first_left"))),
            ]),
            _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "hidden",
          attrs: { type: "radio", name: "display", id: "head" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "tool",
            attrs: { for: "head", onclick: "DisplayMode.loadHead()" },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _vm._v(_vm._s(_vm.tl("display.slot.head"))),
            ]),
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("sentiment_satisfied"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "hidden",
          attrs: { type: "radio", name: "display", id: "ground" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "tool",
            attrs: { for: "ground", onclick: "DisplayMode.loadGround()" },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _vm._v(_vm._s(_vm.tl("display.slot.ground"))),
            ]),
            _c("i", { staticClass: "icon-ground" }),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "hidden",
          attrs: { type: "radio", name: "display", id: "fixed" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "tool",
            attrs: { for: "fixed", onclick: "DisplayMode.loadFixed()" },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _vm._v(_vm._s(_vm.tl("display.slot.frame"))),
            ]),
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("filter_frames"),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.isBedrockStyle()
          ? [
              _c("input", {
                staticClass: "hidden",
                attrs: { type: "radio", name: "display", id: "embedded" },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "tool",
                  attrs: {
                    for: "embedded",
                    onclick: "DisplayMode.loadEmbedded()",
                  },
                },
                [
                  _c("div", { staticClass: "tooltip" }, [
                    _vm._v(_vm._s(_vm.tl("display.slot.embedded"))),
                  ]),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("potted_plant"),
                  ]),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.isBedrockStyle()
          ? [
              _c("input", {
                staticClass: "hidden",
                attrs: { type: "radio", name: "display", id: "on_shelf" },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "tool",
                  attrs: {
                    for: "on_shelf",
                    onclick: "DisplayMode.loadShelf()",
                  },
                },
                [
                  _c("div", { staticClass: "tooltip" }, [
                    _vm._v(_vm._s(_vm.tl("display.slot.on_shelf"))),
                  ]),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("table_view"),
                  ]),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          staticClass: "hidden",
          attrs: { type: "radio", name: "display", id: "gui" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "tool",
            attrs: { for: "gui", onclick: "DisplayMode.loadGUI()" },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _vm._v(_vm._s(_vm.tl("display.slot.gui"))),
            ]),
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("border_style"),
            ]),
          ]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c("p", { staticClass: "panel_toolbar_label" }, [
      _vm._v(_vm._s(_vm.tl("display.reference"))),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "bar tabs_small icon_bar",
      attrs: { id: "display_ref_bar" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "display_sliders" } },
      [
        _c("div", { staticClass: "bar display_slot_section_bar" }, [
          _c("p", { staticClass: "panel_toolbar_label" }, [
            _vm._v(_vm._s(_vm.tl("display.rotation"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tool head_right",
              on: {
                click: function ($event) {
                  return _vm.resetChannel("rotation")
                },
              },
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("replay")])]
          ),
        ]),
        _vm._v(" "),
        _vm._l(_vm.axes, function (axis) {
          return _c(
            "div",
            {
              key: "rotation." + axis,
              staticClass: "bar slider_input_combo",
              attrs: { title: _vm.getAxisLetter(axis).toUpperCase() },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.slot.rotation[axis],
                    expression: "slot.rotation[axis]",
                    modifiers: { number: true },
                  },
                ],
                staticClass: "tool disp_range",
                style: {
                  "--color-thumb":
                    "var(--color-axis-" + _vm.getAxisLetter(axis) + ")",
                },
                attrs: {
                  type: "range",
                  trigger_type: "rotation." + axis,
                  min: "-180",
                  max: "180",
                  step: "1",
                  value: "0",
                },
                domProps: { value: _vm.slot.rotation[axis] },
                on: {
                  input: function ($event) {
                    return _vm.change(axis, "rotation")
                  },
                  mousedown: function ($event) {
                    return _vm.start()
                  },
                  change: _vm.save,
                  __r: function ($event) {
                    _vm.$set(
                      _vm.slot.rotation,
                      axis,
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c("numeric-input", {
                staticClass: "tool disp_text",
                attrs: { min: -180, max: 180, step: 0.5 },
                on: {
                  input: function ($event) {
                    return _vm.change(axis, "rotation")
                  },
                  change: function ($event) {
                    _vm.focusout(axis, "rotation")
                    _vm.save()
                  },
                  mousedown: function ($event) {
                    return _vm.start()
                  },
                },
                model: {
                  value: _vm.slot.rotation[axis],
                  callback: function ($$v) {
                    _vm.$set(_vm.slot.rotation, axis, _vm._n($$v))
                  },
                  expression: "slot.rotation[axis]",
                },
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "bar display_slot_section_bar" }, [
          _c("p", { staticClass: "panel_toolbar_label" }, [
            _vm._v(_vm._s(_vm.tl("display.translation"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tool head_right",
              on: {
                click: function ($event) {
                  return _vm.resetChannel("translation")
                },
              },
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("replay")])]
          ),
        ]),
        _vm._v(" "),
        _vm._l(_vm.axes, function (axis) {
          return _c(
            "div",
            {
              key: "translation." + axis,
              staticClass: "bar slider_input_combo",
              attrs: { title: _vm.getAxisLetter(axis).toUpperCase() },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.slot.translation[axis],
                    expression: "slot.translation[axis]",
                    modifiers: { number: true },
                  },
                ],
                staticClass: "tool disp_range",
                style: {
                  "--color-thumb":
                    "var(--color-axis-" + _vm.getAxisLetter(axis) + ")",
                },
                attrs: {
                  type: "range",
                  trigger_type: "translation." + axis,
                  min:
                    Math.abs(_vm.slot.translation[axis]) < 10
                      ? -20
                      : _vm.slot.translation[axis] > 0
                      ? -70 * 3 + 10
                      : -80,
                  max:
                    Math.abs(_vm.slot.translation[axis]) < 10
                      ? 20
                      : _vm.slot.translation[axis] < 0
                      ? 70 * 3 - 10
                      : 80,
                  step: Math.abs(_vm.slot.translation[axis]) < 10 ? 0.25 : 1,
                  value: "0",
                },
                domProps: { value: _vm.slot.translation[axis] },
                on: {
                  input: function ($event) {
                    return _vm.change(axis, "translation")
                  },
                  mousedown: function ($event) {
                    return _vm.start()
                  },
                  change: _vm.save,
                  __r: function ($event) {
                    _vm.$set(
                      _vm.slot.translation,
                      axis,
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c("numeric-input", {
                staticClass: "tool disp_text",
                attrs: { min: -80, max: 80, step: 0.5 },
                on: {
                  input: function ($event) {
                    return _vm.change(axis, "translation")
                  },
                  change: function ($event) {
                    _vm.focusout(axis, "translation")
                    _vm.save()
                  },
                  mousedown: function ($event) {
                    return _vm.start()
                  },
                },
                model: {
                  value: _vm.slot.translation[axis],
                  callback: function ($$v) {
                    _vm.$set(_vm.slot.translation, axis, _vm._n($$v))
                  },
                  expression: "slot.translation[axis]",
                },
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "bar display_slot_section_bar" }, [
          _c("p", { staticClass: "panel_toolbar_label" }, [
            _vm._v(_vm._s(_vm.tl("display.scale"))),
          ]),
          _vm._v(" "),
          _vm.allowEnablingMirroring()
            ? _c(
                "div",
                {
                  staticClass: "tool head_right",
                  on: {
                    click: function ($event) {
                      return _vm.showMirroringSetting()
                    },
                  },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("flip")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tool head_right",
              on: {
                click: function ($event) {
                  return _vm.resetChannel("scale")
                },
              },
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("replay")])]
          ),
        ]),
        _vm._v(" "),
        _vm._l(_vm.axes, function (axis) {
          return _c(
            "div",
            {
              key: "mirror." + axis,
              staticClass: "bar slider_input_combo",
              attrs: { title: _vm.getAxisLetter(axis).toUpperCase() },
            },
            [
              _vm.allowMirroring()
                ? _c(
                    "div",
                    {
                      staticClass: "tool display_scale_invert",
                      on: {
                        click: function ($event) {
                          return _vm.invert(axis)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "tooltip" }, [
                        _vm._v(_vm._s(_vm.tl("display.mirror"))),
                      ]),
                      _vm._v(" "),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(
                          _vm._s(
                            _vm.slot.mirror[axis]
                              ? "check_box"
                              : "check_box_outline_blank"
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.slot.scale[axis],
                    expression: "slot.scale[axis]",
                    modifiers: { number: true },
                  },
                ],
                staticClass: "tool disp_range scaleRange",
                style: {
                  "--color-thumb":
                    "var(--color-axis-" + _vm.getAxisLetter(axis) + ")",
                },
                attrs: {
                  type: "range",
                  trigger_type: "scale." + axis,
                  id: "scale_range_" + axis,
                  min: _vm.slot.scale[axis] > 1 ? -2 : 0,
                  max: _vm.slot.scale[axis] > 1 ? 4 : 2,
                  step: "0.01",
                  value: "0",
                },
                domProps: { value: _vm.slot.scale[axis] },
                on: {
                  input: function ($event) {
                    return _vm.change(axis, "scale")
                  },
                  mousedown: function ($event) {
                    return _vm.start(axis, "scale")
                  },
                  change: function ($event) {
                    return _vm.save(axis, "scale")
                  },
                  __r: function ($event) {
                    _vm.$set(_vm.slot.scale, axis, _vm._n($event.target.value))
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c("numeric-input", {
                staticClass: "tool disp_text",
                attrs: { min: 0, max: 4, step: 0.01 },
                on: {
                  input: function ($event) {
                    return _vm.change(axis, "scale")
                  },
                  change: function ($event) {
                    _vm.focusout(axis, "scale")
                    _vm.save()
                  },
                  mousedown: function ($event) {
                    return _vm.start()
                  },
                },
                model: {
                  value: _vm.slot.scale[axis],
                  callback: function ($$v) {
                    _vm.$set(_vm.slot.scale, axis, _vm._n($$v))
                  },
                  expression: "slot.scale[axis]",
                },
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.isBedrockStyle() && _vm.slot.slot_id == "gui"
          ? _c(
              "div",
              {
                staticClass: "bar",
                on: {
                  click: function ($event) {
                    return _vm.toggleFitToFrame()
                  },
                },
              },
              [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.slot.fit_to_frame == true },
                }),
                _vm._v(" "),
                _c("label", { staticStyle: { "padding-top": "3px" } }, [
                  _vm._v("Fit to Frame"),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.reference_model == "player"
          ? [
              _c("div", { staticClass: "bar display_slot_section_bar" }, [
                _c("p", { staticClass: "panel_toolbar_label" }, [
                  _vm._v(_vm._s(_vm.tl("display.pose_angle"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bar slider_input_combo" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.pose_angle,
                        expression: "pose_angle",
                        modifiers: { number: true },
                      },
                    ],
                    staticClass: "tool disp_range",
                    attrs: {
                      type: "range",
                      min: "-180",
                      max: "180",
                      step: "1",
                    },
                    domProps: { value: _vm.pose_angle },
                    on: {
                      __r: function ($event) {
                        _vm.pose_angle = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("numeric-input", {
                    staticClass: "tool disp_text",
                    attrs: { min: -180, max: 180, step: 0.5 },
                    model: {
                      value: _vm.pose_angle,
                      callback: function ($$v) {
                        _vm.pose_angle = _vm._n($$v)
                      },
                      expression: "pose_angle",
                    },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.slot.slot_id == "ground"
          ? [
              _c("div", { staticClass: "bar display_slot_section_bar" }, [
                _c("p", { staticClass: "panel_toolbar_label" }, [
                  _vm._v(_vm._s(_vm.tl("display.animate_preview"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bar slider_input_combo" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.animate_preview,
                      expression: "animate_preview",
                      modifiers: { number: true },
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.animate_preview)
                      ? _vm._i(_vm.animate_preview, null) > -1
                      : _vm.animate_preview,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.animate_preview,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = _vm._n(null),
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.animate_preview = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.animate_preview = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.animate_preview = $$c
                      }
                    },
                  },
                }),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isBedrockStyle()
          ? [
              _c("div", { staticClass: "bar display_slot_section_bar" }, [
                _c("p", { staticClass: "panel_toolbar_label" }, [
                  _vm._v(_vm._s(_vm.tl("display.rotation_pivot"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tool head_right",
                    on: {
                      click: function ($event) {
                        return _vm.resetChannel("rotation_pivot")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("replay"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bar display_inline_inputs" },
                _vm._l(_vm.axes, function (axis) {
                  return _c("numeric-input", {
                    key: "rotation_pivot." + axis,
                    staticClass: "tool disp_text is_colored",
                    style: {
                      "--corner-color":
                        "var(--color-axis-" + _vm.getAxisLetter(axis) + ")",
                    },
                    attrs: {
                      title: _vm.getAxisLetter(axis).toUpperCase(),
                      min: -10,
                      max: 10,
                      step: 0.05,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.change(axis, "rotation_pivot")
                      },
                      change: function ($event) {
                        _vm.focusout(axis, "rotation_pivot")
                        _vm.save()
                      },
                      mousedown: function ($event) {
                        return _vm.start()
                      },
                    },
                    model: {
                      value: _vm.slot.rotation_pivot[axis],
                      callback: function ($$v) {
                        _vm.$set(_vm.slot.rotation_pivot, axis, _vm._n($$v))
                      },
                      expression: "slot.rotation_pivot[axis]",
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "bar display_slot_section_bar" }, [
                _c("p", { staticClass: "panel_toolbar_label" }, [
                  _vm._v(_vm._s(_vm.tl("display.scale_pivot"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tool head_right",
                    on: {
                      click: function ($event) {
                        return _vm.resetChannel("scale_pivot")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("replay"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bar display_inline_inputs" },
                _vm._l(_vm.axes, function (axis) {
                  return _c("numeric-input", {
                    key: "scale_pivot." + axis,
                    staticClass: "tool disp_text is_colored",
                    style: {
                      "--corner-color":
                        "var(--color-axis-" + _vm.getAxisLetter(axis) + ")",
                    },
                    attrs: {
                      title: _vm.getAxisLetter(axis).toUpperCase(),
                      min: -10,
                      max: 10,
                      step: 0.05,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.change(axis, "scale_pivot")
                      },
                      change: function ($event) {
                        _vm.focusout(axis, "scale_pivot")
                        _vm.save()
                      },
                      mousedown: function ($event) {
                        return _vm.start()
                      },
                    },
                    model: {
                      value: _vm.slot.scale_pivot[axis],
                      callback: function ($$v) {
                        _vm.$set(_vm.slot.scale_pivot, axis, _vm._n($$v))
                      },
                      expression: "slot.scale_pivot[axis]",
                    },
                  })
                }),
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "js/display_mode/DisplayModePanel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__